import { api } from 'restaurantAdmin/api';

export interface ReportsResponse {
  trafficReportUrl: string | null;
  metabaseDashboardUrl: string | null;
  metabaseFinanceDashboardUrl: string | null;
}

export const getReports = (restaurantId: string): Promise<ReportsResponse> => {
  return api.get(`/restaurants/${restaurantId}/reports`);
};
